import * as Preact from "preact"
import Pointer from "poin"

import App from "@fae/source/models/App.js"
import Step from "@fae/source/models/Step.js"
import Geometry from "@fae/source/utility/Geometry.js"
// import Random from "@fae/source/utility/Random.js"
// const random = new Random()

import Dice from "@fae/source/data/games/ember/views/Dice.jsx"
import DiceLayout from "@fae/source/data/games/ember/views/DiceLayout.jsx"
import UnitManagementSection from "@fae/source/data/games/ember/views/UnitManagementSection.jsx"

import CarryOn from "@fae/source/data/games/ember/utility/CarryOn.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"

import "./VictoryModals.less"

import CHESTS from "@fae/source/data/games/ember/chests.js"
let RANDOMIZED_CHESTS = Object.values(CHESTS)

import items from "@fae/source/data/games/ember/items.jsx"

export default function VictoryModals() {
    return [
        CongratsModal.script()
    ]
}

const results = [
    {"type": "silver", "amount": 10},
    // food, wood, ore
    // torches kindled
    // enemies killed
    // experience gained
    // --
    // potions
    // (do now) artifacts
    // pre-chosen weapon
    // pre-chosen artifact
    // (do now) choose 1 of 3 artifact
    // choose 1 of 3 weapon
    // (do now) unpack ally weapons
    // level-up, choose 1 of 2 perks
    // announce: new things added to the pool (tier up)
    // bestiary
    {"type": "item", "item": {...items["burning-blade"], "power": 20}},
    {"type": "rites", "items": [
        {...items["firekeeper-greataxe"], "power": 20},
        {...items["burning-blade"], "power": 20},
    ]},
]

class CongratsModal {
    static script(params) {
        return PlotSteps.CustomViewModal({
            "view": (stage) => <CongratsModal stage={stage} params={params}/>
        })
    }
    render() {
        if(App?.game == undefined) return
        return (
            <div class="CongratsModal">
                <div class="SelectedItemCursor" hasSelected={window.selectedItem != undefined} style={{"top": Pointer.position.y, "left": Pointer.position.x}}>
                    <Dice item={window.selectedItem} anchored={"bottom"}/>
                </div>
                <UnitManagementSection stage={this.props.stage} direction="horizontal"/>
                <div class="ResultsSection">
                    <div class="Header">
                        <div class="BigText">Success</div>
                    </div>
                    <div class="ResultList">
                        {results.map((result) => {
                            if(result.hasBeenClicked == true) return
                            if(result.type == "silver") {
                                return (
                                    <div class="Result" onClick={this.onClickResult(results, result)}>
                                        <div class="Tab"/>
                                        <div class="Text">
                                            {result.amount} silver
                                        </div>
                                    </div>
                                )
                            }
                            if(result.type == "rites") {
                                return (
                                    <div class="Result" onClick={this.onClickResult(results, result)}>
                                        <div class="Tab"/>
                                        <div class="Text">
                                            Final Rites
                                        </div>
                                    </div>
                                )
                            }
                            if(result.type == "item") {
                                return (
                                    <div class="Result" onClick={this.onClickResult(results, result)}>
                                        <div class="DiceTab">
                                            <Dice item={result.item}/>
                                        </div>
                                        <div class="Text">
                                            {result.item.title || "???"}
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                    <div class="Button">
                        <div class="SkipButton" onClick={this.onClickContinue()} isVisible={window.selectedChest != undefined && window.selectedItem == undefined}>
                            Skip
                        </div>
                        <div class="ContinueButton" onClick={this.onClickContinue()} isVisible={window.selectedChest == undefined && window.selectedItem == undefined}>
                            Continue
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    onClickResult(results, result) {
        return (event) => {
            const MOUSE_BUTTON = 0
            if(event.button != MOUSE_BUTTON) return

            result.hasBeenClicked = true
            if(result.type == "silver"
            && result.amount != undefined) {
                window.goldCount = window.goldCount || 0
                window.goldCount += (result.amount || 0)
            }
            if(result.type == "rites"
            && result.items != undefined) {
                result.items.forEach((item) => {
                    results.push({
                        "type": "item",
                        "item": item
                    })
                })
            }
            if(result.type == "item"
            && result.item != undefined) {
                window.selectedItem = result.item
                window.selectedItemSlotKey = "draft"
            }
        }
    }
    onClickContinue() {
        return (event) => {
            CarryOn(this.props.stage)
        }
    }
}
